import React from "react";
import { cn } from "@/utils/cn";

type ChevronIconProps = {
  className?: string;
};

export const ChevronIcon: React.FC<ChevronIconProps> = ({ className }) => (
  <svg
    className={cn("h-6 w-6", className)}
    fill="none"
    viewBox="0 0 24 24"
    strokeWidth="1.5"
    stroke="currentColor"
  >
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M19.5 8.25l-7.5 7.5-7.5-7.5"
    />
  </svg>
);
